import { render, staticRenderFns } from "./PortfolioCreatePage.vue?vue&type=template&id=1f4d89f3&scoped=true&"
import script from "./PortfolioCreatePage.vue?vue&type=script&lang=js&"
export * from "./PortfolioCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCreatePage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PortfolioCreatePage.vue?vue&type=style&index=1&id=1f4d89f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d89f3",
  null
  
)

export default component.exports